<script lang="ts">
    import CN from "classnames";

    export let position: "center" | "right" = "right";
</script>

<div class={CN("gw-ig-branding", `gw-ig-branding--${position}`)}>
    <a
        class="gw-ig-branding__link"
        href="https://growavelabs.com/instaphotos?utm_source=ssw&utm_medium=referral&utm_campaign=insta_widget"
        rel="noopener noreferrer"
        target="_blank"
    >
        Powered by InstaPhotos
    </a>
</div>

<style>
    .gw-ig-branding--right {
        text-align: end;
    }

    .gw-ig-branding--center {
        text-align: center;
    }

    .gw-ig-branding__link {
        display: block;
        padding: 10px 0;
        color: var(--gw-grey-text-color);
        font-size: 0.8em;
        text-decoration: none;
    }
</style>
